export default __webpack_public_path__ + "static/media/stairs.6c9da41b.svg";